import {atom} from "recoil";
import {IvyUsersMeType} from "../types/MemberTypes";

export const IvyAuthorizationTokenAtom = atom<string>({
    key: 'ivy.authorization.token',
    default: ''
})

export const IvyMyInfoAtom = atom<IvyUsersMeType>({
    key: 'ivy.my.info',
    default: {} as IvyUsersMeType
})